import * as tslib_1 from "tslib";
import { observable, action, computed } from "mobx";
import { createTransformer } from "mobx-utils";
import { parseTimeZone } from "./TimeZoneParser";
import { getTimeZoneFormatted } from "./TimeZoneFormatter";
import { getCurrentTime } from "./CurrentTimeHelper/CurrentTimeHelper";
import { formatTime } from "./CurrentTimeFormatter/CurrentTimeFormatter";
var Time = /** @class */ (function () {
    function Time() {
        var _this = this;
        this.currentTimeFormatted = createTransformer(function (timeFormat) {
            return formatTime(_this.currentTime, timeFormat);
        });
        this.eventsManager = new EventsManager();
        this.eventsManager.addEventListener("timezoneChanged", this, this.onTimeZoneChanged.bind(this), true);
    }
    Object.defineProperty(Time, "getInstance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: true,
        configurable: true
    });
    Time.prototype.init = function (provider) {
        if (typeof this.getServerDate === "undefined" && provider.getServerDate) {
            this.getServerDate = provider.getServerDate;
        }
        if (typeof this.currentTimeZone === "undefined" && provider.currentTimeZone) {
            this.currentTimeZone = parseTimeZone(provider.currentTimeZone);
        }
    };
    Time.prototype.activate = function () {
        this.updateTime();
    };
    Time.prototype.onTimeZoneChanged = function (timeZone) {
        this.currentTimeZone = parseTimeZone(timeZone);
    };
    Object.defineProperty(Time.prototype, "timeZoneFormatted", {
        get: function () {
            return getTimeZoneFormatted(this.currentTimeZone);
        },
        enumerable: true,
        configurable: true
    });
    Time.prototype.updateTime = function () {
        this.currentTime = getCurrentTime(this.getServerDate(), this.currentTimeZone);
        this.timeOutInterval = setTimeout(this.updateTime.bind(this), 1000);
    };
    Time.prototype.deactivate = function () {
        clearTimeout(this.timeOutInterval);
    };
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", Number)
    ], Time.prototype, "currentTimeZone", void 0);
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", Date)
    ], Time.prototype, "currentTime", void 0);
    tslib_1.__decorate([
        action,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], Time.prototype, "onTimeZoneChanged", null);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], Time.prototype, "timeZoneFormatted", null);
    tslib_1.__decorate([
        action,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", []),
        tslib_1.__metadata("design:returntype", void 0)
    ], Time.prototype, "updateTime", null);
    return Time;
}());
export { Time };
//# sourceMappingURL=Time.js.map